<template>
  <!-- Selector multiple de etiquetas con un circulo que se marca, pintado con
       el color de cada etiqueta, y chips del mismo color para lo elegido. Lo
       usan el formulario de Envios y el dialogo de etiquetas de la obligacion. -->
  <v-autocomplete
    :value="value"
    :items="items"
    item-text="name"
    item-value="_id"
    :label="label"
    multiple
    chips
    deletable-chips
    :loading="loading"
    :disabled="disabled"
    @input="$emit('input', $event)"
  >
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-action class="mr-3">
          <v-icon :color="tagBackground(item)">
            {{ isSelected(item) ? "check_circle" : "radio_button_unchecked" }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-chip
        small
        label
        close
        class="tag-select__chip"
        :color="tagBackground(item)"
        :text-color="textColorFor(tagBackground(item))"
        @click:close="removeTag(item)"
      >{{ item.name }}</v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
"use strict";

import { tagBackground, textColorFor } from "@/utils/tag-color";

export default {
  name: "tag-select",
  props: {
    // Ids de las etiquetas elegidas.
    value: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    label: { type: String, default: "Etiquetas" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    tagBackground,
    textColorFor,
    isSelected(item) {
      return this.value.indexOf(item._id) !== -1;
    },
    removeTag(item) {
      this.$emit("input", this.value.filter(id => id !== item._id));
    }
  }
};
</script>

<style lang="scss">
.tag-select__chip.v-chip {
  border-radius: 8px;
  font-weight: 600;
}
</style>
